/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable meterpoints
import { tableSchemaBase as columns } from '../meter-points.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IMeterpointsDatatableSlice {
	meterpointsDatatableOptions: TColumnsSchema[];
	setMeterpointsDatatableOptions: (
		_meterpointsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeMeterpointsDatatableSlice = (
	s: any
): any => ({
	meterpointsDatatableOptions:
		s.meterpointsDatatableOptions,
});

const initialState = {
	meterpointsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createMeterpointsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IMeterpointsDatatableSlice
> = (set) => ({
	...initialState,
	setMeterpointsDatatableOptions: (
		_meterpointsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			meterpointsDatatableOptions:
				_meterpointsDatatableOptions,
		}),
});
